<script setup lang="ts">
import { useLearningPathAttendeeStore } from "~/store/learning-path/learning-path-attendee.store";
import Attendee from "./attendees-tab/Attendee.vue";
import Attendees from "./attendees-tab/Attendees.vue";

const route = useRoute();
const learningPathAttendeesStore = useLearningPathAttendeeStore();
const { showAttendee } = storeToRefs(learningPathAttendeesStore);

onMounted(() => {
  if (route.query.attendee_id) {
    learningPathAttendeesStore.handleLearningPathAttendee(true);
  }
});
</script>

<template>
  <Transition name="fade" mode="out-in">
    <div :key="showAttendee ? 'attendee' : 'attendees'">
      <Attendee v-if="showAttendee" />
      <Attendees v-else />
    </div>
  </Transition>
</template>

<style lang="scss" scoped>
.fade-enter-active {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.fade-leave-active {
  transition: all 0.25s cubic-bezier(0.4, 0, 1, 1);
}

.fade-enter-from {
  opacity: 0;
  transform: translateX(30px);
}

.fade-leave-to {
  opacity: 0;
  transform: translateX(-30px);
}

.fade-enter-to,
.fade-leave-from {
  opacity: 1;
  transform: translateX(0);
}
</style>
